export default __webpack_public_path__ + "static/media/curvedDownArrowRight.910d88dc.svg";